import React, { useState, useEffect, useContext } from 'react';
import classNames from 'classnames';
import Axios from 'axios';
import { HexpertStart } from './HexpertStart';
import { HexpertSteps } from './HexpertSteps';
import { HexpertContext } from '../contexts/HexPertProvider';
import { getUnitForField } from '../helpers/unitsConversion';
import { WeFitLoadingBlock } from '../blocks/WeFitLoadingBlock';
import { Hexpert as endpoints } from '@services/endpoints';
import './HexpertPage.scss';

export type HexpertPageProps = {
  Title: string;
  SubTitle: string;
  StartLabel: string;
  Description: string;
  startAction?: () => void;
  startForm?: boolean;
};

enum HexPageAnimation {
  HALF = 'c-hex-page-background-cover-half',
  OPEN = 'c-hex-page-background-cover-open',
}

export const HexpertPage = () => {
  const [pageAnim, setPageAnim] = useState<HexPageAnimation>(null);
  const { state, dispatch } = useContext(HexpertContext);
  const [initialResultLoading, setInitialResultLoading] = useState(false);

  useEffect(() => {
    if (state?.startSteps) {
      setPageAnim(HexPageAnimation.OPEN);
    } else {
      setPageAnim(HexPageAnimation.HALF);
    }
  }, [state?.startSteps]);
  useEffect(() => {
    if (window?.location?.search && window?.location?.search?.includes('sn=')) {
      setInitialResultLoading(true);
      dispatch({ type: 'setStartForm' });
      if (state?.pageProps) {
        Axios.get(endpoints.getHexpertResult + window?.location?.search, {
          params: {
            culture: window['lang'],
          },
        }).then((res) => {
          dispatch({
            type: 'setResult',
            payload: {
              redirectUrl: window?.location?.href?.replace('&show-request-quote=true', ''),
              ...res.data,
              Summary: {
                ...res.data.Summary,
                FormDataItems: res.data?.Summary?.FormDataItems?.map((item) => ({
                  ...item,
                  unit: getUnitForField(item.FieldName, state.pageProps?.Forms),
                })),
              },
            },
          });
          const answers = {};
          res.data?.Summary?.FormDataItems?.forEach(
            (field) => (answers[field.FieldName] = field.FieldValue)
          );
          dispatch({
            type: 'setInitalAnswers',
            payload: {
              answers: answers,
              showProductResult: true,
              currentForm: state.pageProps?.MappedForms?.find(
                (form) => form.formGuid === res?.data?.FormGuid
              )?.type,
              startSteps: 'start',
            },
          });

          setInitialResultLoading(false);
        });
      }
    }
  }, [window?.location, state?.pageProps]);

  return (
    <>
      <div className='c-hex-page'>
        <>
          <div
            className={classNames('c-hex-page-background-cover', {
              [pageAnim]: state?.startForm,
            })}
          />

          {state?.pageProps &&
            (initialResultLoading ? (
              <WeFitLoadingBlock />
            ) : (
              <>
                <HexpertSteps />
                <HexpertStart {...state?.pageProps} />
              </>
            ))}
        </>
      </div>
    </>
  );
};
